module.exports = __webpack_public_path__ + "img/img-159.498c7b39.png";